/* eslint-disable import/prefer-default-export */
import { useEffect } from "react";

// eslint-disable-next-line import/extensions
import * as awsExports from "../../../aws-exports";
// eslint-disable-next-line import/extensions
import featureFlags from "../utils/featureFlags";

type AuthHeaders = { Authorization: string };

const WARMUP_PATHS = [
  "/accounts/health",
  "/feeds/health",
  "/ingredients/health",
];

export const useWarmupFpPerformance = (): void => {
  useEffect(() => {
    const fpPlatformApiUrl = awsExports.fpPlatformApiUrl as string | undefined;
    if (!featureFlags.warmupFpPerformance || !fpPlatformApiUrl) return;

    const getIdToken = awsExports.getIdToken as () => Promise<AuthHeaders>;
    getIdToken()
      .then((headers) => {
        WARMUP_PATHS.forEach((path) => {
          fetch(`${fpPlatformApiUrl}${path}`, { headers }).catch(() => {});
        });
      })
      .catch(() => {});
  }, []);
};
